import axios from 'axios'
import { getAccessToken, getDeviceId, getPushToken } from './auth'
import store from './store'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
    // create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        let access_token = getAccessToken();
        if (access_token != undefined) {
            access_token = 'Bearer ' + getAccessToken();

        } else {
            access_token = '';
        }

        let os_type = 'web';
        const userAgent = navigator.userAgent;
        if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
            os_type = 'webios';
        } else if (userAgent.includes("Android")) {
            os_type = 'webandroid';
        }

        // do something before request is sent
        const header = {
            'X-OS-TYPE': os_type,
            'X-OS-VERSION': '1.0',
            'X-APP-VERSION': '1.0',
            'X-DEVICE-NAME': navigator.userAgent,
            'X-API-ID': 'API-ID-SUGUKOI-MS',
            'X-API-KEY': 'API-KEY-SUGUKOI-MS',
            // Bearer là chuẩn chung nên phải thêm vào
            'Authorization': access_token,
            
        }
        if (getPushToken()) {
            header['X-PUSH-TOKEN'] = getPushToken();

        }
        config.headers = header; // set headers default before request
        if (getDeviceId()) {
            config.headers['X-DEVICE-ID'] = getDeviceId()

        } else {
            // No device id, redirect login page
            // window.location.href('login');
        }

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug

        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
            // if the custom code is not 20000, it is judged as an error.
        if (response.status !== 200) {
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        if (error.response.status === 401) {
            // store.dispatch('request/setCountRequest')
            if (!window.location.href.includes('login')) {
                store.dispatch('login/resetAccessToken').then(() => {}).catch(() => {
                    store.dispatch('login/justLogout')
                })
            }
        }
        return Promise.reject(error)
    }
)

export default service